import {
  MOBILE_TABLET_ID,
  HOME_AND_LIFESTYLE_ID,
  ELECTRONICS_AND_APPLIANCES_ID
} from '../constants';
import config from '../../../config';
const { IMAGE_CDN_DOMAIN } = config;

export const getArrayObjectValue = (arr, key) => {
  const arrIndex = arr.findIndex(item => item.key === key);
  return arrIndex && arr[arrIndex] ? arr[arrIndex].value : null;
};

export const isEscrow = id => {
  if (
    id === MOBILE_TABLET_ID ||
    id === HOME_AND_LIFESTYLE_ID ||
    id === ELECTRONICS_AND_APPLIANCES_ID
  ) {
    return true;
  }
  return false;
};

export const openNewTab = (url = '') => {
  if (typeof window !== 'undefined' && url !== null) {
    window.open(url);
  }
};

export const getProductTypes = adObject => {
  const productTypes = [];
  let priorityFilters = [];
  let otherkeys = [];
  let role;
  let filters;
  const { cat, attr = [] } = adObject;
  switch (cat.id) {
    case '93':
      // jobs
      role = attr.filter(item => item.key === 'Role');
      if (role.length > 0) {
        productTypes.push({ key: 'Role', val: role[0].value });
      }

      filters = attr.filter(
        item => !['role', 'job id', 'recommended_score'].includes(`${item.key}`.toLowerCase())
      );
      if (filters.length > 0) {
        const index = Math.round(Math.random() * (filters.length - 1));
        const { key, value } = filters[index];
        productTypes.push({ key, val: value });
        filters = filters.filter(item => item.key !== filters[index].key);
        if (productTypes.length === 1 && filters.length > 0) {
          const { key, value } = filters[Math.round(Math.random() * (filters.length - 1))];
          productTypes.push({ key, val: value });
        }
      }
      return productTypes;
    case '60':
      // cars & bikes
      priorityFilters = ['Brand_name', 'Model'];
      otherkeys = attr.filter(
        item => !['brand_name', 'ad id', 'model'].includes(`${item.key}`.toLowerCase())
      );
      priorityFilters.concat(otherkeys.map(item => item.key));
      break;
    case '1': // community
    case '161': // matrimonial
    case '179': // entertainment
    case '194': // education
    case '246': // pets
    case '281': // events
      // core
      priorityFilters = ['Pet_Type'];
      otherkeys = attr.filter(item => !['ad id', 'pet_type'].includes(`${item.key}`.toLowerCase()));
      priorityFilters.concat(otherkeys.map(item => item.key));
      break;
    default:
      break;
  }

  priorityFilters.forEach(key => {
    if (productTypes.length < 2) {
      const productType = attr.filter(item => item.key === key);
      if (productType.length > 0) {
        productTypes.push({ key, val: productType[0].value });
      }
    } else {
      return productTypes;
    }
  });

  return productTypes;
};

export const getCTAHighlights = catid => {
  // ToDo: when this function gets bigger, move to graphql
  const assetPath = `${IMAGE_CDN_DOMAIN}/core/clsfd/assets`;
  switch (catid) {
    case '60':
      return [
        { icon: `${assetPath}/ic-get-all-details-2x.png`, step: 'Get all details' },
        { icon: `${assetPath}/ic-schedule-visit-2x.png`, step: 'Schedule a visit' },
        { icon: `${assetPath}/ic-negotiate-2x.png`, step: 'Finalize the price' }
      ];
    case '40':
    case '269':
    case '247':
      return [
        { icon: `${assetPath}/ic-get-all-details-2x.png`, step: 'Get all details' },
        { icon: `${assetPath}/ic-schedule-visit-bazaar-2x.png`, step: 'Schedule a visit' },
        { icon: `${assetPath}/ic-negotiate-2x.png`, step: 'Negotiate price' }
      ];
    default:
      return null;
  }
};

export const fieldChecker = (name, value) => {
  if (name === 'mobile') {
    const val = '' + value;
    return val.substr(val.length - 10);
  }
  return value;
};

export const SameObjects = (obj1, obj2) => {
  for (const key in obj1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return obj1.length === obj2.length;
};
